/**
 * Crown Studio: Price per item display
 * Updates per-item price when quantity changes (volume pricing).
 * Unique implementation - no third-party copyright.
 */
(function () {
  var DELIM = "%%%";

  function parseTiers(el) {
    var qtyStr = el.getAttribute("data-tier-quantities");
    var priceStr = el.getAttribute("data-tier-prices");
    if (!qtyStr || !priceStr) return null;
    var qtys = qtyStr.split(",").map(function (s) {
      return parseInt(s, 10) || 0;
    });
    var prices = priceStr.split(DELIM);
    if (qtys.length !== prices.length) return null;
    return { qtys: qtys, prices: prices };
  }

  function getTotalQuantity(input) {
    if (!input) return 1;
    var cartQty =
      parseInt(input.getAttribute("data-cart-quantity") || "0", 10) || 0;
    var inputQty = parseInt(input.value, 10) || 1;
    return cartQty + inputQty;
  }

  function tierForQuantity(tiers, qty) {
    var idx = -1;
    for (var i = 0; i < tiers.qtys.length; i++) {
      if (qty >= tiers.qtys[i]) idx = i;
    }
    return idx >= 0 ? tiers.prices[idx] : tiers.prices[tiers.prices.length - 1];
  }

  function updatePerItem(el, tiers, qty) {
    var label = el.getAttribute("data-per-item-label") || "per item";
    var price = tierForQuantity(tiers, qty);
    el.textContent = price + " " + label;
  }

  function findPerItemForInput(input) {
    var form = input.closest("form");
    if (!form || !form.id) return null;
    var idMatch = form.id.match(/^product-form-(.+)$/);
    if (!idMatch) return null;
    var sectionId = idMatch[1];
    var priceBlock = document.getElementById("price-" + sectionId);
    if (!priceBlock) return null;
    return priceBlock.querySelector("[data-per-item][data-tier-quantities]");
  }

  function onQuantityChange(e) {
    var input = e.target;
    if (input.getAttribute("name") !== "quantity") return;
    var perItemEl = findPerItemForInput(input);
    if (!perItemEl) return;
    var tiers = parseTiers(perItemEl);
    if (!tiers) return;
    var qty = getTotalQuantity(input);
    updatePerItem(perItemEl, tiers, qty);
  }

  function init() {
    var perItemNodes = document.querySelectorAll(
      "[data-per-item][data-tier-quantities]",
    );
    perItemNodes.forEach(function (el) {
      var tiers = parseTiers(el);
      if (!tiers) return;
      var form = el.closest("form") || el.closest("product-form");
      if (!form) return;
      var input = form.querySelector
        ? form.querySelector('input[name="quantity"]')
        : null;
      if (input) updatePerItem(el, tiers, getTotalQuantity(input));
    });
  }

  document.addEventListener("input", onQuantityChange);
  document.addEventListener("change", onQuantityChange);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  function parseJsonBreaks(el) {
    var raw = el.getAttribute("data-price-breaks");
    if (!raw) return null;
    try {
      var breaks = JSON.parse(raw);
      if (!Array.isArray(breaks) || breaks.length === 0) return null;
      return breaks;
    } catch (e) {
      return null;
    }
  }

  function getBasePrice(el) {
    return el.getAttribute("data-variant-price") || "";
  }

  function tierPriceForQty(breaks, basePrice, qty) {
    var price = basePrice;
    for (var i = 0; i < breaks.length; i++) {
      if (qty >= breaks[i].quantity) price = breaks[i].price;
    }
    return price;
  }

  function findQtyPerItemForInput(input) {
    var wrapper = input.closest(".product-quantity-wrapper");
    if (!wrapper) return null;
    return wrapper.querySelector("[data-price-per-item]");
  }

  function updateQtyPerItem(el, qty) {
    var breaks = parseJsonBreaks(el);
    if (!breaks) return;
    var basePrice = getBasePrice(el);
    var price = tierPriceForQty(breaks, basePrice, qty);
    el.textContent = "at " + price + "/ea";
  }

  function onQtyInputChange(e) {
    var input = e.target;
    if (input.getAttribute("name") !== "quantity") return;
    var perItemEl = findQtyPerItemForInput(input);
    if (!perItemEl) return;
    var cartQty =
      parseInt(input.getAttribute("data-cart-quantity") || "0", 10) || 0;
    var inputQty = parseInt(input.value, 10) || 1;
    updateQtyPerItem(perItemEl, cartQty + inputQty);
  }

  document.addEventListener("input", onQtyInputChange);
  document.addEventListener("change", onQtyInputChange);

  /* --- Update quantity-label__cart-count and max after add-to-cart --- */
  function updateCartCountLabels(cartData) {
    var variantCounts = {};
    if (cartData && cartData.items) {
      cartData.items.forEach(function (item) {
        var vid = String(item.variant_id);
        variantCounts[vid] = (variantCounts[vid] || 0) + item.quantity;
      });
    }

    document
      .querySelectorAll('.product-quantity-wrapper[id^="quantity-wrapper-"]')
      .forEach(function (wrapper) {
        var input = wrapper.querySelector('input[name="quantity"]');
        if (!input) return;

        var variantInput = null;
        if (input.hasAttribute("form")) {
          var formEl = document.getElementById(input.getAttribute("form"));
          if (formEl) variantInput = formEl.querySelector('input[name="id"]');
        }
        if (!variantInput) return;

        var vid = String(variantInput.value);
        var count = variantCounts[vid] || 0;

        input.setAttribute("data-cart-quantity", count);

        /* Adjust max based on cart quantity */
        var variantMax = input.getAttribute("data-max-variant");
        if (variantMax) {
          var maxNum = parseInt(variantMax, 10);
          var remaining = maxNum - count;
          if (remaining < 1) remaining = 1;
          input.setAttribute("max", remaining);
          /* Clamp current value if it exceeds new max */
          var currentVal = parseInt(input.value, 10) || 1;
          if (currentVal > remaining) {
            input.value = remaining;
          }
        }

        /* Refresh price-per-item with updated cart quantity */
        var perItemEl = wrapper.querySelector("[data-price-per-item]");
        if (perItemEl) {
          var minQty = parseInt(input.getAttribute("min") || "1", 10) || 1;
          updateQtyPerItem(perItemEl, count + minQty);
        }

        /* Update max quantity rule label */
        var maxRuleEl = wrapper.querySelector("[data-quantity-max-rule]");
        if (maxRuleEl) {
          var effectiveMax = parseInt(
            maxRuleEl.getAttribute("data-effective-max") || "0",
            10,
          );
          if (effectiveMax > 0) {
            var remaining = effectiveMax - count;
            if (remaining < 1) remaining = 1;
            var template = maxRuleEl.getAttribute("data-max-template") || "";
            maxRuleEl.textContent = template.replace("[max]", remaining);
          }
        }

        /* Update volume pricing block cart quantity + re-highlight active tier */
        var sectionIdMatch = wrapper.id.match(/^quantity-wrapper-(.+)$/);
        if (sectionIdMatch) {
          var priceBlock = document.getElementById(
            "quantity-price-block-" + sectionIdMatch[1],
          );
          if (priceBlock) {
            priceBlock.setAttribute("data-cart-quantity", count);
            var table = priceBlock.querySelector("quantity-price-table");
            if (table && typeof table.highlightActiveTier === "function") {
              var inputQty = parseInt(input.value, 10) || 1;
              table.highlightActiveTier(count + inputQty);
            }
          }
        }

        var cartCountEl = wrapper.querySelector("[data-quantity-cart-count]");
        if (!cartCountEl) return;

        if (count > 0) {
          cartCountEl.classList.remove("hidden");
          cartCountEl.textContent = "(" + count + " in cart)";
        } else {
          cartCountEl.classList.add("hidden");
        }
      });
  }

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartState && event.cartState.items) {
        updateCartCountLabels(event.cartState);
      } else {
        fetch(window.routes.cart_url + ".js")
          .then(function (r) {
            return r.json();
          })
          .then(updateCartCountLabels)
          .catch(function () {});
      }
    });
  }
})();
